const setDocumentTitleAndFavicon = (brand) => {
  if (process.env.VUE_APP_MODE === "dev") document.title = `D-dots Admin`;
  else
    document.title = `${brand.charAt(0).toUpperCase() + brand.slice(1)} Admin`;
  let icon =
    process.env.VUE_APP_MODE === "dev"
      ? "/icon/dev.ico"
      : `/icon/${brand}.ico?v=2`;
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.getElementsByTagName("head")[0].appendChild(link);
  }
  link.href = icon;
};

const getBrandFromLocation = () => {
  let brand = window.location.hostname.split("-")[0];
  return brand === "linecrm" || brand === "5t8z5pcj" ? "d-dots" : brand;
};

async function setupConfig() {
  try {
    const brand = getBrandFromLocation();

    setDocumentTitleAndFavicon(brand);
  } catch (error) {
    console.error("Error fetching configuration:", error);
    window.alert(
      "An error occurred while setting up the configuration. Please try again later."
    );
    return null;
  }
}

export { setupConfig };
